/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrashAlt} from '@fortawesome/pro-duotone-svg-icons';

const RemoveIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faTrashAlt} {...props} />
);

export default RemoveIcon;
